var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "bandana-new-pack-notice position-relative",
        staticStyle: {
          background:
            "linear-gradient(to bottom, #f46a4533, #cd491c33), url('https://img.fortawesome.com/1ce05b4b/wa-pattern.svg') repeat, linear-gradient(to bottom, #f46a45 , #cd491c)",
          "background-size": "100% 150%, auto, 100% 150%",
          "background-repeat": "no-repeat, repeat, no-repeat",
          color: "white",
        },
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row roomy padding-y-2xl" }, [
            _c("div", { staticClass: "column-12 display-flex" }, [
              _c(
                "div",
                {
                  staticClass:
                    "display-none tablet:display-flex laptop:align-middle align-left padding-y-md padding-right-md",
                  staticStyle: { "flex-shrink": "0", "flex-grow": "0" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "icon-box",
                      staticStyle: {
                        width: "52px",
                        height: "52px",
                        "border-radius": "8px",
                        "background-color": "#f46a45",
                        border: "2px solid white",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                      },
                    },
                    [_c("i", { staticClass: "fa-solid fa-xl fa-web-awesome" })]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tablet:display-flex align-between align-middle",
                  staticStyle: {
                    "--button-margin-bottom": "0",
                    "flex-grow": "1",
                  },
                },
                [
                  _c("div", { staticClass: "display-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "tablet:display-none padding-right-lg",
                        staticStyle: { "flex-shrink": "0", "flex-grow": "0" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "icon-box",
                            staticStyle: {
                              width: "52px",
                              height: "52px",
                              "border-radius": "8px",
                              "background-color": "#f46a45",
                              border: "2px solid white",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-solid fa-2x fa-web-awesome",
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "p",
                        {
                          staticClass: "padding-right-2xl",
                          staticStyle: {
                            "font-size": "20px",
                            "line-height": "1.25em",
                          },
                        },
                        [
                          _c("strong", [_vm._v("Web Awesome has landed!")]),
                          _vm._v(
                            "\n                No frameworks. No build steps. Just clean, fast web components.\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "margin-top-lg tablet:margin-top-0 flex-row tablet:flex-column laptop:flex-row",
                      staticStyle: {
                        display: "flex",
                        gap: "var(--spacing-xs)",
                        "flex-shrink": "0",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "button flat",
                          staticStyle: {
                            "--button-color": "var(--fa-navy)",
                            "--button-background": "white",
                            "--button-hover-background": "#FFAF99",
                            "--button-hover-color": "var(--fa-navy)",
                            "flex-grow": "1",
                          },
                          attrs: {
                            href: "https://webawesome.com/?utm_source=fontawesome&utm_medium=banner&utm_campaign=launch",
                            target: "_blank",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fa-solid fa-xl fa-arrow-up-right-from-square margin-right-xs",
                          }),
                          _vm._v("\n              Explore WA\n            "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button flat",
                          staticStyle: {
                            "--button-color": "white",
                            "--button-background": "var(--fa-navy)",
                            "--button-hover-background": "#FFAF99",
                            "--button-hover-color": "var(--fa-navy)",
                            "flex-grow": "1",
                          },
                          attrs: {
                            href: "https://webawesome.com/purchase?utm_source=fontawesome&utm_medium=banner&utm_campaign=launch",
                            target: "_blank",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fa-solid fa-xl fa-rocket-launch margin-right-xs",
                          }),
                          _vm._v(
                            "\n              20% Off Launch Sale\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }